import { isMobile } from "react-device-detect";

import { ImportMobileView } from "./views/ImportMobileView";
import ImportPlayersView from "./views/ImportPlayersView";

const ImportPlayers = () => {
  let view: JSX.Element;
  if (isMobile) view = <ImportMobileView />;
  else view = <ImportPlayersView />;

  return (
    <main
      className="flex min-h-screen pt-4 mx-auto text-white touch-device:pb-8 touch-device:pt-8"
      style={{
        background:
          "linear-gradient(180deg, #1C2A37 0%, #161C21 100%), #1D1D1D",
      }}
    >
      {view}
    </main>
  );
};

export default ImportPlayers;
